import { createSlice } from '@reduxjs/toolkit';
import { ridesApi } from '@store/rtk';

const initialState = {
  ridesTableData: {},
  standingOrdersTableData: {},
};

export const ridesTableSlice = createSlice({
  name: 'ridesTable',
  initialState,
  reducers: {
    emptyRides: (state) => {
      state.ridesTableData = {};
      state.standingOrdersTableData = {};
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      ridesApi.endpoints.getRidesByModulePost.matchFulfilled,
      (state, { payload }) => {
        state.ridesTableData = {
          ...state.ridesTableData,
          ...payload,
          rows: payload.content,
          requestTablePageChange: ridesApi.endpoints.getRidesByModulePost,
        };
      }
    );
    builder.addMatcher(
      ridesApi.endpoints.getStandingOrdersByModulePost.matchFulfilled,
      (state, { payload }) => {
        state.standingOrdersTableData = {
          ...state.standingOrdersTableData,
          ...payload,
          rows: payload.content,
          requestTablePageChange:
            ridesApi.endpoints.getStandingOrdersByModulePost,
        };
      }
    );
    builder.addMatcher(
      ridesApi.endpoints.getContractorPortalRides.matchFulfilled,
      (state, { payload }) => {
        state.ridesTableData = {
          ...state.ridesTableData,
          ...payload,
          rows: payload.content,
          requestTablePageChange: ridesApi.endpoints.getContractorPortalRides,
        };
      }
    );
    builder.addMatcher(
      ridesApi.endpoints.getContractorPortalStandingOrders.matchFulfilled,
      (state, { payload }) => {
        state.standingOrdersTableData = {
          ...state.standingOrdersTableData,
          ...payload,
          rows: payload.content,
          requestTablePageChange:
            ridesApi.endpoints.getContractorPortalStandingOrders,
        };
      }
    );
  },
});

export const selectRidesTable = (state) => state.ridesTable;
export const { emptyRides } = ridesTableSlice.actions;

export const ridesTableReducer = ridesTableSlice.reducer;
